export const GET_PLATAFORMA_TENANTS = 'GET_PLATAFORMA_TENANTS';
export const GET_PLATAFORMAS_BY_TENANT = 'GET_PLATAFORMAS_BY_TENANT';
export const ADD_PLATAFORMA_TENANT = 'ADD_PLATAFORMA_TENANT';
export const UPDATE_PLATAFORMA_TENANT = 'UPDATE_PLATAFORMA_TENANT';
export const DELETE_PLATAFORMA_TENANT = 'DELETE_PLATAFORMA_TENANT';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_PLATAFORMAS_TENANT = 'CLEAR_PLATAFORMAS_TENANT';
